import { Component, OnInit } from '@angular/core';
import { Observable, takeUntil } from 'rxjs';

import { PageNames } from 'src/app/configs/page-names.enum';
import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';

import {
  CustomResultOfListOfGetAllPossibleIndicesDto,
  CustomResultOfListOfGetAllPossiblePointPerIndexDto,
  CustomResultOfPaginatedListOfGetUserValuePurchasePointsWithPaginationDto,
  GetAllPossiblePointPerIndexDto,
  GetEnumValuesDto,
  GetUserValuePurchasePointsWithPaginationDto,
} from 'src/app/core/api/models';
import {
  UserValueOfPurchasePointStrategiesService,
  UserValueOfPurchasesPointsService,
} from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { ConsoleService } from 'src/app/core/services/console.service';
import { BaseIndexModule } from 'src/app/pages/shared/base';
import { BaseIndexPageComponent } from '../../../shared/base/components/base-index-page.component';
import { ValueOfPurchasePointStrategiesFormComponent } from './value-of-purchase-point-strategies-form/value-of-purchase-point-strategies-form.component';
import { ValueOfPurchasePointsFormComponent } from './value-of-purchase-points-form/value-of-purchase-points-form.component';
import { ValueOfPurchaseStrategiesComponent } from './value-of-purchase-strategies/value-of-purchase-strategies.component';

@Component({
  selector: 'app-value-of-purchase-points',
  templateUrl: './value-of-purchase-points.component.html',
  imports: [
    BaseIndexModule,
    ValueOfPurchasePointsFormComponent,
    ValueOfPurchaseStrategiesComponent,
    ValueOfPurchasePointStrategiesFormComponent,
  ],
})
export class ValueOfPurchasePointsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.userValueOfPurchasePoints;

  modelWithPagination$: Observable<CustomResultOfPaginatedListOfGetUserValuePurchasePointsWithPaginationDto>;
  items$: Observable<Array<GetUserValuePurchasePointsWithPaginationDto>>;
  paginationApiMethodName =
    this.currentService
      .userValueOfPurchasesPointsGetUserValueOfPurchasePointsWithPagination
      .name;
  pointPerIndexModel: Array<GetAllPossiblePointPerIndexDto> = [];
  UserValueOfPurchaseIndexEnumValues: GetEnumValuesDto[] = [];
  allPossibleIndices: GetEnumValuesDto[] = [];
  isShowStrategies: boolean = false;
  isShowPointStrategies: boolean = false;
  //#endregion

  constructor(
    protected currentService: UserValueOfPurchasesPointsService,
    protected userValueOfPurchasePointStrategiesService: UserValueOfPurchasePointStrategiesService
  ) {
    super();
  }
  ngOnInit() {
    super.ngOnInit();
    this.pageConfig.showAuditBtn = false;
  }

  getEnumsValues() {
    this.getEnumValuesApi('UserValueOfPurchaseIndex')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (values) => (this.UserValueOfPurchaseIndexEnumValues = values)
      );
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: `${this.tableVocabs}index`,
        name: 'index',
        hasSearch: true,
        wrap: true,
        type: 'enum',
        enumName: 'UserValueOfPurchaseIndex',
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region Api
  // Delete
  baseDeleteApi(id: number) {
    this.unSubs();

    this.pageConfig.loading = true;
    this.lastSelectedItemId = id;
    this.idPropertyName = 'index';

    this.currentService
      .userValueOfPurchasesPointsDelete({ body: { index: id } })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseDeleteObserver);
  }
  //#endregion

  onCreate(type?: any, isFormModal?: boolean) {
    try {
      this.setParentQueryString();

      this.location.go(window.location.pathname + '?key-formType=create');
      this.pageConfig.isVisibleForm = true;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  onUpdate(item?, setUrl = true) {
    this.showParent = false;
    this.setParentQueryString();
    if (setUrl) {
      this.location.go(
        window.location.pathname +
          '?' +
          QueryStringTypesEnum.Update_key +
          '=' +
          item.id
      );
    }
    this.formPageConfig.editData = item;
    this.formPageConfig.isEditMode = true;

    this.pageConfig.isVisibleForm = true;
  }

  onStrategies() {
    this.isShowStrategies = true;
  }

  getAllPossibleIndices() {
    try {
      this.userValueOfPurchasePointStrategiesService
        .userValueOfPurchasePointStrategiesGetAllPossibleIndices()
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (possibleIndices: CustomResultOfListOfGetAllPossibleIndicesDto) => {
            if (possibleIndices.isSucceed)
              this.allPossibleIndices = possibleIndices.data;
          }
        );
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  onPointStrategies() {
    this.unSubs();
    this.pageConfig.loading = true;
    this.getAllPossibleIndices();
    this.userValueOfPurchasePointStrategiesService
      .userValueOfPurchasePointStrategiesGetAllPossiblePointPerIndex()
      .pipe(this.basePipeOperators())
      .subscribe(
        (result: CustomResultOfListOfGetAllPossiblePointPerIndexDto) => {
          if (result.isSucceed) {
            this.pointPerIndexModel = result.data;
            this.isShowPointStrategies = true;
          }
        },
        (error) => {
          ConsoleService.error('error', error);
        }
      );
  }
  
}
